import { render, staticRenderFns } from "./SharedAccountVerification.vue?vue&type=template&id=66dea67a&"
import script from "./SharedAccountVerification.vue?vue&type=script&lang=js&"
export * from "./SharedAccountVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports